export enum SliceKeys {
  DRAWER = "drawer",
  SNACKBAR = "snackbar",
  AUTH = "auth",
  PRODUCT = "product",
  DIALOG = "dialog",
  ORGANISATION = "organisation",
  USER = "user",
  BANNED_IP = "bannedIP",
  API_Account = "apiAccount",
  BILLED_OPERATION = "billedOperation",
  LICENCE = "licence",
  SOFTWARE_LICENCE = "softwareLicence",
  PRICING = "pricing",
  ORDER = "order",
  TRACC_Usage = "traccUsage"
}
